import { useInfiniteQuery } from "react-query";
import { ForumPostService } from "../../types/services/forum/ForumService";
import { db } from "../../services/firebase";
import { applyVariablesToQuery } from "../../services/db";
import { FORUMS_REPLY_PARENT_FIELD, FORUMS_REPLY_TIMESTAMP_FIELD } from "../../types/db";

/** Maximum reply per page (for pagination) */
const REPLIES_PER_PAGE = 5;

export const useForumPostReplies = (postId: string, limit: number = REPLIES_PER_PAGE) => {
    //fetch list of replies of the post
    const { data, ...restData } = useInfiniteQuery(
        ["forum", "post", postId, "replies"],
        ({ pageParam }) => new ForumPostService(db).postReplyService(postId)
            .paginate(
                limit,
                (collection) => {
                    return applyVariablesToQuery(collection,
                        {
                            orderBy: { field: FORUMS_REPLY_TIMESTAMP_FIELD, dir: 'desc' },//most recent first
                            where: [
                                {
                                    fieldPath: FORUMS_REPLY_TIMESTAMP_FIELD,
                                    opStr: '<=',
                                    value: Date.now(),
                                },
                                {
                                    fieldPath: FORUMS_REPLY_PARENT_FIELD,
                                    opStr: '==',
                                    value: null,
                                },
                            ]
                        })
                },
                pageParam
            ),
        {
            enabled: !!postId,
            getNextPageParam: (_, pages) => {
                if (!pages?.length)
                    return undefined
                const lastPage = pages[pages.length - 1];
                if (lastPage.documents.length < limit) {
                    //if last page was not fetching a complete page, we don't have more to fetch
                    return undefined;
                }
                return lastPage.lastDoc;//the last item of the last page
            },
            refetchOnWindowFocus: false,
        }
    );

    return {
        ...restData,
        data: data?.pages.flatMap((page) => page.documents),
    }
}